import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { Container } from '../../ui/Primitives';
import { Button } from '../../ui/Button';
import { Field, inputClass } from '../../ui/Field';
import { Seo } from '../../Seo';
import { useAcademyHub } from '../../../context/AcademyHub';

/** The only way into the admin area. Learner accounts are not accepted. */
export function StaffSignIn() {
  const {
    staffSignIn
  } = useAcademyHub();
  const [email, setEmail] = React.useState('');
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState('');
  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!email.trim() || !code.trim()) {
      setError('Enter your staff email and access code.');
      return;
    }
    const problem = staffSignIn(email, code);
    setError(problem ?? '');
  };
  return <>
      <Seo title="Staff sign in, Cavalla Academy" description="Staff access." path="/academy/admin" noIndex data-id="element-416" data-mp="2zwb61d3dmn3n" />
      <Container className="flex justify-center py-20 sm:py-28" data-id="element-417" data-mp="33xoezw1rn6es">
        <div className="w-full max-w-[420px]" data-id="element-418" data-mp="2vemviqjhr212">
          <ShieldIcon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-419" data-mp="2qgbm2gx3ytjd" />
          <h1 className="mt-4 font-display text-[28px] leading-tight text-ink" data-id="element-420" data-mp="2qdz3q2nfuh5s">Staff sign in</h1>
          <p className="mt-2 text-[15px] text-body" data-id="element-421" data-mp="2lj1y75pdapxn">
            This area is for Academy instructors and administrators. Learner accounts cannot open it.
          </p>
          <form onSubmit={submit} noValidate className="mt-8 space-y-5" data-id="element-422" data-mp="2ch2g0a2m9ft4">
            <Field id="staff-email" label="Staff email" required data-id="element-423" data-mp="27p2eid6weeuf">
              <input id="staff-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} className={inputClass} data-id="element-424" data-mp="27nr6g16f6kxi" />
            </Field>
            <Field id="staff-code" label="Access code" required data-id="element-425" data-mp="1trvtebypc421">
              <input id="staff-code" type="password" autoComplete="current-password" value={code} onChange={e => setCode(e.target.value)} className={inputClass} data-id="element-426" data-mp="1os13obqnxkik" />
            </Field>
            {error && <p role="alert" className="text-small text-[#FF8B7A]" data-id="element-427" data-mp="156r5wg0pyxqd">
                {error}
              </p>}
            <Button type="submit" size="lg" className="w-full" data-id="element-428" data-mp="1a5u9rx4yqxwr">
              Sign in
            </Button>
          </form>
          <p className="mt-6 text-small text-muted" data-id="element-429" data-mp="22t6m7ehetpcc">Need access? A platform admin can add you as an instructor.</p>
        </div>
      </Container>
    </>;
}